<template>
  <div class="common_main">
    <div>
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="searchForm"
        label-width="70px"
      >
        <search-form
          @search="getListData"
          @refresh="resetSearch"
        >
          <div slot="content">
            <el-form-item label="合同编号：">
              <el-input
                size="mini"
                v-model.trim="searchForm.contractNumber"
                placeholder="请输入合同编号"
                clearable

              ></el-input>
            </el-form-item>

      			<el-form-item label="签约客户：">
      			  <el-input
      			    size="mini"
      			    v-model.trim="searchForm.signedCustomer"
      			    placeholder="请输入签约客户"
      			    clearable

      			  ></el-input>
      			</el-form-item>

          </div>
        </search-form>
      </el-form>
    </div>
    <div class="common_main_box">
      <!-- <h1>日历</h1>
      <el-calendar>
        <template
          slot="dateCell"
          slot-scope="{date, data}">
          <p :class="data.isSelected ? 'is-selected' : ''">
            {{ data.day.split('-').slice(1).join('-') }} {{ data.isSelected ? '✔️' : ''}}
          </p>
          <p @click="dianji">点击</p>
        </template>
      </el-calendar> -->
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'Dom',
    computed: {
      ...mapState('common/commontest', ['name'])
    },
    data() {
      return {
        searchForm: {
          contractNumber: '',
          signedCustomer: ''
        }
      }
    },
    methods: {
      dianji(e) {
        e.stopPropagation()
        console.log(111)
      },
      getListData() {

      },
      resetSearch() {

      }

    }
  }
</script>

<style scoped lang="scss">
.is-selected {
  color: #1989FA;
}
.search-form {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dom/Dom.vue